import { render } from "./DefaultNotificationItem.vue?vue&type=template&id=73103aa6&scoped=true"
import script from "./DefaultNotificationItem.vue?vue&type=script&lang=js"
export * from "./DefaultNotificationItem.vue?vue&type=script&lang=js"

import "./DefaultNotificationItem.vue?vue&type=style&index=0&id=73103aa6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73103aa6"]])

export default __exports__